import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["container"];

  connect () {
    this.containerTarget.scrollLeft = this.containerTarget.offsetWidth;
  }
}
